import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import './gallery.scss';
import OfficeGallery from './OfficeGallery';
import { useTranslation } from 'react-i18next';
import SearchCarWidget from "../SearchCarWidget";
import SupplierCards from './SupplierCards';

// Placeholder image for offices
// import placeholderImg from '../../../build/car placeholder.jpg';

const HomeContent = ({ onSubmit, params, wl, locations, currencies, cur }) => {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const [showLocationContent, setShowLocationContent] = useState(Boolean(params?.fromLocationCode));

  // Utility function to capitalize first letter
  const capitalizeFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const getLocationName = useCallback((code) => {
    if (!Array.isArray(locations)) return code;
    const loc = locations.find(l => String(l.locationCode) === String(code));
    return loc ? loc.locationName : code;
  }, [locations]);

  const getConversionRate = useCallback((sourceCurrency, targetCurrency) => {
    return currencies[targetCurrency] / currencies[sourceCurrency]
  }, [currencies])

  // Utility: get location name by code
  // const getLocationName = (code) => {
  //   if (!Array.isArray(locations)) return code;
  //   const loc = locations.find(l => String(l.locationCode) === String(code));
  //   return loc ? loc.locationName : code;
  // };

  const [locationName, setLocationName] = useState(getLocationName(params?.fromLocationCode));

  useEffect(() => {
    // if (params && params?.fromLocationCode === params?.toLocationCode && params?.fromLocationCode?.match(/168|1|340/)) {
    if (params && params?.fromLocationCode) {
      setShowLocationContent(true);
    } else {
      setShowLocationContent(false);
    }

  }, [params]);

  useEffect(() => {
    setLocationName(getLocationName(params?.fromLocationCode));
  }, [locations, params?.fromLocationCode, getLocationName]);

  useEffect(() => {
    // Remove any existing script with the same id before adding a new one
    const existingScript = document.getElementById('pp-widget-main');
    if (existingScript) {
      console.log('Removing existing script with id pp-widget-main');
      existingScript.parentNode.removeChild(existingScript);
    }
    const script = document.createElement('script');
    script.src = '/pp-widget/main.js';
    script.async = true;
    script.id = 'pp-widget-main';

    if (showLocationContent && lng && cur && params?.fromLocationCode && locationName ) {
      // Create offersContainer dynamically and append to the dedicated wrapper
      const offersContainer = document.createElement('div');
      offersContainer.id = 'offersContainer';
      offersContainer.setAttribute('lang', lng);
      offersContainer.setAttribute('data-items-to-show', '9');
      offersContainer.setAttribute('data-pu-location-code', params.fromLocationCode);
      offersContainer.setAttribute('data-pu-location-name', locationName);
      offersContainer.setAttribute('data-currency-code', cur);
      offersContainer.setAttribute('data-conv-rate', getConversionRate("ILS", cur));
      offersContainer.setAttribute('data-lang', lng);

      // Find the dedicated wrapper to append offersContainer to
      const wrapper = document.getElementById('offersContainerWrapper');
      if (wrapper) {
        console.log('Appending offersContainer and script to offersContainerWrapper, while wrapper has children:', wrapper.children.length );
        wrapper.appendChild(offersContainer);
        wrapper.appendChild(script);
      }
    }

    return () => {
      console.log('Cleaning up HomeContent component');
      const wrapper = document.getElementById('offersContainerWrapper');
      if (wrapper) {
        while (wrapper.firstChild) {
          console.log(`Removing child from offersContainerWrapper ${wrapper.firstChild.id} with shadowRoot: ${wrapper.firstChild.shadowRoot} `);
          wrapper.removeChild(wrapper.firstChild);
        }
      }
    };
  }, [showLocationContent, lng, cur, locationName]);

  return (
    <div>
      <div className="container col-xxl-8 p-0 py-md-5">
        <div className="row no-gutters flex-lg-row-reverse align-items-center g-5 py-0 py-md-5">
          <div className="col-lg-6 px-4">
            {wl ? <img className="d-block mx-auto mb-4" src={`/${wl}.png`} alt="logo" width="300rem" /> : ''}
            {wl ? '' : 
              showLocationContent ? 
              <h1 className="display-5 fw-bold">{capitalizeFirst(t('carRental'))} {t('in')}{locationName}</h1> :
              <h1 className="display-5 fw-bold lh-1 mb-3">{t('homepageWelcomeHeader')}</h1>
            }
            <p className="lead d-none d-sm-block">
              {t('homepageLead1')}{showLocationContent ? ` ${t('in')}${locationName}` : ''}.&nbsp;
              <b>{wl ? wl : t('brand')}</b> - {t('homepageLead2')}
            </p>
          </div>
          <div className="col-12 col-sm-8 col-lg-6 px-0 px-sm-2">
            <SearchCarWidget onSubmit={onSubmit} params={params} minimized={false} autoFocus={true} />
          </div>
        </div>
      </div>
      <div className="b-example-divider"></div>
      {showLocationContent ? (
      <>
        <div className="bg-white px-4 py-5 text-center">
          <h2 className="display-5 fw-bold">{capitalizeFirst(t('cheapCarsTitle'))} {t('in')}{locationName}</h2>
          <div className="col-lg-6 mx-auto">
            <p className="lead mb-4">{t('nextWeekPrices')}</p>
          </div>
          <div id="offersContainerWrapper"></div>
        </div>
        <div className="b-example-divider"></div>
      </>
      ) : ''}
      {/* Gallery of car rental offices */}
      {showLocationContent && (
        <>
          <OfficeGallery locationName={locationName} locationCode={params.fromLocationCode} t={t} />
          <div className="b-example-divider"></div>
        </>
      )}
      {/* Supplier Cards Section */}
      {showLocationContent && (
        <>
          <SupplierCards locationCode={params.fromLocationCode} t={t} />
          <div className="b-example-divider"></div>
        </>
      )}
      <div className="container col-xxl-8 px-4 py-5">
        <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
          <div className="col-lg-6">
            <h2 className="display-5 fw-bold lh-1 mb-3">{t('homepageHeader2')}</h2>
            <p className="lead">{t('homepageLead3')}</p>
          </div>
          <div className="col-lg-6">
            <img src="/rental logos.jpg" width="786" height="182" className="d-block mx-lg-auto img-fluid" alt="logo" loading="lazy" />
          </div>
        </div>
      </div>
      <div className="b-example-divider"></div>
      <div className="bg-white px-4 py-5 text-center">
        <h2 className="display-5 fw-bold">{t('homepageHeader3')}</h2>
        <div className="col-lg-6 mx-auto">
          <p className="lead mb-4">{t('homepageLead4')}</p>
        </div>
        <img src={`/${t("testimonialImage")}`} width="500" height="625" className="d-block mx-auto mb-4 img-fluid" alt="testimonial" loading="lazy" />
      </div>
    </div>
  );
};

const mapStateToProps = ({ vendors, results, ui, locations, currencies }) => ({
  // dir: ui.direction,
  wl: ui.whiteLabel,
  locations: locations.data,
  currencies: currencies.data,
  cur: ui.currency,
});

export default connect(mapStateToProps)(HomeContent);
// export default HomeContent;